import BasePerimeter from '@/perimeters/BasePerimeter';

export default new BasePerimeter({
  purpose: 'source',

  can: {
    all() {
      return this.hasPermission('source-read');
    },

    create() {
      return this.hasPermission('source-write');
    },

    read() {
      return this.hasPermission('source-read');
    },

    update(source) {
      return this.isCreator(source) || this.hasPermission('source-update');
    },

    destroy() {
      return this.hasPermission('source-delete');
    }
  },

  isCreator(source) {
    if (!source) return false;

    return this.child.id === source.child_id;
  }
});
